import intl from "react-intl-universal";

const STATUS_STYLES = {
  processed: "bg-emerald-50 text-emerald-700 dark:bg-emerald-950/40 dark:text-emerald-400",
  pending: "bg-amber-50 text-amber-700 dark:bg-amber-950/40 dark:text-amber-400",
  failed: "bg-red-50 text-red-700 dark:bg-red-950/40 dark:text-red-400",
};

export const BaasStableStatusBadge = ({ status }) => (
  <span
    className={`inline-flex rounded-full px-2.5 py-0.5 text-xs font-medium ${STATUS_STYLES[status] ?? STATUS_STYLES.pending}`}
  >
    {intl.get(`baas.stables.status.${status}`)}
  </span>
);

export const BaasStableOperationBadge = ({ operation }) => (
  <span className="inline-flex rounded-full bg-gray-100 px-2.5 py-0.5 text-xs font-semibold text-gray-700 dark:bg-brand-dark-elevated dark:text-gray-300">
    {intl.get(`baas.stables.operation.${operation}`)}
  </span>
);
